import React, { useState, useEffect, useCallback } from 'react'
import { Card, Table } from 'reactstrap'
import { _fetchApi } from '../api'
import Gray from '../Gray'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { LoadingComponent } from '.'

function Overview({
  indicator,
  country,
  year_from,
  year_to,
  region,
  type_of_data,
  setFormattedData = (f) => f,
  setForm = (f) => f,
}) {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  // const indicator = searchParams.get('indicator')
  // const country = searchParams.get('country')
  // const year_from = searchParams.get('year_from')
  // const year_to = searchParams.get('year_to')
  // const region = searchParams.get('region')
  // const type_of_data = searchParams.get('type_of_data')
  // const new_indicator = searchParams.get('new_indicator')

  // const getQueryParams = (key, value) => ({
  //   indicator,
  //   country,
  //   year_from,
  //   year_to,
  //   region,
  //   type_of_data,
  //   new_indicator,
  //   [key]: value,
  // })

  const [data, setData] = useState([])

  const get_by_indicator = useCallback(() => {
    setLoading(true)
    _fetchApi(
      `/get_by_indicator?query_type=indicator&year_from=${year_from}&year_to=${year_to}&type_of_data=${type_of_data}`,
      (d) => {
        setLoading(false)
        setData(d.results)
        setFormattedData(d.results)
        // console.log(d);
      },
      (err) => {
        setLoading(false)
        console.log(err)
      },
    )
  }, [year_from, year_to, type_of_data, setFormattedData])

  useEffect(() => {
    get_by_indicator()
  }, [get_by_indicator])

  return (
    <div>
      <Card className="p-3 mt-3">
        <h3 className="text-center">
          World economic outlook regional Average per indicator ({year_from} -{' '}
          {year_to})
        </h3>

        {/* <Gray report={report} indicator={indicator} /> */}
        {loading && <LoadingComponent />}
        <div>
          <Table bordered striped>
            <thead>
              <tr>
                <th>Indicator</th>
                <th className="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              {data.map((d, i) => (
                <tr key={i}>
                  <td
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(
                        `indicator-breakdown?indicator=${d.indicator}&country=${country}&region=${region}&year_from=${year_from}&year_to=${year_to}&type_of_data=${type_of_data}&new_indicator=${d.indicator}`,
                      )
                    }}
                  >
                    {d.indicator}
                  </td>
                  <td className="text-end">
                    {((d.amt * 100) / 100).toFixed(4)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>
      <Card
        body
        className="p-3 mt-3"
        style={{ height: '60vh', overflow: 'auto' }}
      >
        <h3 className="text-center">
          World economic outlook regional Average per indicator ({year_from} -{' '}
          {year_to})
        </h3>
        <Gray
          report={data.map((a) => ({
            ...a,
            indicator: `${a['indicator'].slice(0, 18)}...`,
            Total: a['average'],
          }))}
          // report={country[0] === "Regional Outlook" ? data : newArr}
          indicator={[indicator]}
          xDataKey="indicator"
          yDataKey="Total"
          xAngle={-45}
          //   stageOne={stageOne}
        />
      </Card>
    </div>
  )
}

export default Overview
